import { dew as _environmentsDew } from "../../../../environments";
import { dew as _coreDew } from "../../../../core";
import { dew as _Dew } from "../../..";
import * as _urlSearchParams2 from "@ungap/url-search-params";
var _urlSearchParams = "default" in _urlSearchParams2 ? _urlSearchParams2.default : _urlSearchParams2;
import { dew as _serializationDew } from "../../../../serialization";
import * as _urlJoin2 from "url-join";
var _urlJoin = "default" in _urlJoin2 ? _urlJoin2.default : _urlJoin2;
import { dew as _errorsDew } from "../../../../errors";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  /**
   * This file was auto-generated by Fern from our API Definition.
   */
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });
  var __importStar = exports && exports.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
  var __awaiter = exports && exports.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var __rest = exports && exports.__rest || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Records = void 0;
  const environments = __importStar(_environmentsDew());
  const core = __importStar(_coreDew());
  const Flatfile = __importStar(_Dew());
  const url_search_params_1 = __importDefault(_urlSearchParams);
  const serializers = __importStar(_serializationDew());
  const url_join_1 = __importDefault(_urlJoin);
  const errors = __importStar(_errorsDew());
  class Records {
    constructor(_options) {
      this._options = _options;
    }
    /**
     * Returns records from a sheet in a workbook
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    get(sheetId, request = {}, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const {
          versionId,
          sinceVersionId,
          sortField,
          sortDirection,
          filter,
          filterField,
          searchValue,
          searchField,
          ids,
          pageSize,
          pageNumber,
          includeCounts,
          includeLength,
          includeLinks,
          includeMessages,
          for: for_,
          q
        } = request;
        const _queryParams = new url_search_params_1.default();
        if (versionId != null) {
          _queryParams.append("versionId", versionId);
        }
        if (sinceVersionId != null) {
          _queryParams.append("sinceVersionId", sinceVersionId);
        }
        if (sortField != null) {
          _queryParams.append("sortField", sortField);
        }
        if (sortDirection != null) {
          _queryParams.append("sortDirection", sortDirection);
        }
        if (filter != null) {
          _queryParams.append("filter", filter);
        }
        if (filterField != null) {
          _queryParams.append("filterField", filterField);
        }
        if (searchValue != null) {
          _queryParams.append("searchValue", searchValue);
        }
        if (searchField != null) {
          _queryParams.append("searchField", searchField);
        }
        if (ids != null) {
          if (Array.isArray(ids)) {
            for (const _item of ids) {
              _queryParams.append("ids", _item);
            }
          } else {
            _queryParams.append("ids", ids);
          }
        }
        if (pageSize != null) {
          _queryParams.append("pageSize", pageSize.toString());
        }
        if (pageNumber != null) {
          _queryParams.append("pageNumber", pageNumber.toString());
        }
        if (includeCounts != null) {
          _queryParams.append("includeCounts", includeCounts.toString());
        }
        if (includeLength != null) {
          _queryParams.append("includeLength", includeLength.toString());
        }
        if (includeLinks != null) {
          _queryParams.append("includeLinks", includeLinks.toString());
        }
        if (includeMessages != null) {
          _queryParams.append("includeMessages", includeMessages.toString());
        }
        if (for_ != null) {
          _queryParams.append("for", for_);
        }
        if (q != null) {
          _queryParams.append("q", q);
        }
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/records`),
          method: "GET",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          queryParameters: _queryParams,
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.GetRecordsResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Updates existing records in a workbook sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    update(sheetId, request, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/records`),
          method: "PUT",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          body: yield serializers.Records.jsonOrThrow(request, {
            unrecognizedObjectKeys: "strip"
          }),
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.VersionResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Adds records to a workbook sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    insert(sheetId, request, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/records`),
          method: "POST",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          body: yield serializers.records.insert.Request.jsonOrThrow(request, {
            unrecognizedObjectKeys: "strip"
          }),
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.RecordsResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Deletes records from a workbook sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    delete(sheetId, request = {}, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const {
          ids
        } = request;
        const _queryParams = new url_search_params_1.default();
        if (ids != null) {
          if (Array.isArray(ids)) {
            for (const _item of ids) {
              _queryParams.append("ids", _item);
            }
          } else {
            _queryParams.append("ids", ids);
          }
        }
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/records`),
          method: "DELETE",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          queryParameters: _queryParams,
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.Success.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Searches for the given searchValue in a field and replaces all instances of that value with replaceValue
     */
    findAndReplaceDeprecated(sheetId, request, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const {
            fieldKey,
            searchValue,
            filter,
            pageSize,
            pageNumber
          } = request,
          _body = __rest(request, ["fieldKey", "searchValue", "filter", "pageSize", "pageNumber"]);
        const _queryParams = new url_search_params_1.default();
        _queryParams.append("fieldKey", fieldKey);
        _queryParams.append("searchValue", searchValue);
        if (filter != null) {
          _queryParams.append("filter", filter);
        }
        if (pageSize != null) {
          _queryParams.append("pageSize", pageSize.toString());
        }
        if (pageNumber != null) {
          _queryParams.append("pageNumber", pageNumber.toString());
        }
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/replace`),
          method: "PUT",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          queryParameters: _queryParams,
          body: yield serializers.FindAndReplaceRecordRequestDeprecated.jsonOrThrow(_body, {
            unrecognizedObjectKeys: "strip"
          }),
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.RecordsResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          throw new errors.FlatfileError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Searches for all values that match the 'find' value (globally or for a specific field via 'fieldKey') and replaces them with the 'replace' value. Wrap 'find' value in double quotes for exact match (""). Returns a versionId for the updated records
     */
    findAndReplace(sheetId, request, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const {
            filter,
            filterField,
            searchValue,
            searchField,
            ids
          } = request,
          _body = __rest(request, ["filter", "filterField", "searchValue", "searchField", "ids"]);
        const _queryParams = new url_search_params_1.default();
        if (filter != null) {
          _queryParams.append("filter", filter);
        }
        if (filterField != null) {
          _queryParams.append("filterField", filterField);
        }
        if (searchValue != null) {
          _queryParams.append("searchValue", searchValue);
        }
        if (searchField != null) {
          _queryParams.append("searchField", searchField);
        }
        if (ids != null) {
          if (Array.isArray(ids)) {
            for (const _item of ids) {
              _queryParams.append("ids", _item);
            }
          } else {
            _queryParams.append("ids", ids);
          }
        }
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/find-replace`),
          method: "PUT",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          queryParameters: _queryParams,
          body: yield serializers.FindAndReplaceRecordRequest.jsonOrThrow(_body, {
            unrecognizedObjectKeys: "strip"
          }),
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.VersionResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          throw new errors.FlatfileError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    _getAuthorizationHeader() {
      return __awaiter(this, void 0, void 0, function* () {
        return `Bearer ${yield core.Supplier.get(this._options.token)}`;
      });
    }
  }
  exports.Records = Records;
  return exports;
}